import React, { Fragment, useEffect, useContext } from "react";
import UnitsTable from "./UnitsTable";
import AuthContext from "../../../context/auth/AuthContext";
import ProjectContext from "../../../context/project/ProjectContext";
import IProjectContext from "../../../types/ProjectState";
import {
  AssetUnitsMaster,
  Suffix,
  AssetUnitsSuffix,
  ProjectUnitSuffix,
  AssetTypes,
} from "../../../types/project";
import {
  AlertColor,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";
import Alert from "../../common/Alert";
import AddProjectUnit from "./AddProjectUnit";
import { tableRows } from "./transformRows";
import Loader from "../../common/Loader";
import AlertContext from "../../../context/alert/AlertContext";

const UnitsConfiguration: React.FC = () => {
  console.log("New Units configuration");
  const projectContext = useContext<IProjectContext>(ProjectContext);
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { showSnackbar } = alertContext;
  const { user } = authContext;
  const {
    assetLookup,
    assetSuffixes,
    projectSuffixes,
    getProjectAssetsV2,
    getProjectRawAssetsV2,
    getAssetTypesV2,
    getAssetLookupV2,
    clearProjectAssets,
    selectedProject,
    loading,
    assetGroups,
    assetTypes,
    addProjectUnitsV2,
    deleteProjectUnitsV2,
    updateProjectUnitV2,
    generateNewUnitID,
    addNewUnitsV2,
    intelliFiberUserRoles,
  } = projectContext;

  const [projectAssets, setProjectAssets] = React.useState<AssetUnitsMaster[]>(
    []
  );
  const [projectRawAssets, setProjectRawAssets] = React.useState<
    ProjectUnitSuffix[]
  >([]);
  const [rows, setRows] = React.useState<AssetUnitsMaster[]>([]);
  const [deleteRecords, setDeleteRecords] = React.useState<ProjectUnitSuffix[]>(
    []
  );
  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [alertMessage, setAlertMessage] = React.useState<{
    message: string;
    type: AlertColor;
  }>({ message: "", type: "success" });
  const [searchTerm, setSearchTerm] = React.useState("");
  const [editDialogOpen, setEditDialogOpen] = React.useState<boolean>(false);
  const [deletedialog, setDeletedialog] = React.useState<boolean>(false);
  const [editProps, setEditProps] = React.useState<any>(null);

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const checkIsEditable = () => {
    //check User's Role
    return getUserRoleType() === "Central GIS Team";
  };
  useEffect(() => {
    if (selectedProject) {
      console.log("$$$UNits loading Proj:", selectedProject);
      fetchProjectAssets(selectedProject.ID);
    }
    return () => {
      console.log("$$$UNits clearing Proj:");
      if (clearProjectAssets) clearProjectAssets();
    };
  }, []);

  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  }, [showAlert]);

  // to handle search
  useEffect(() => {
    if (searchTerm && searchTerm !== "") {
      console.log("&&&USEE SEARCH Term:", searchTerm);
      setRows(
        rows
          .filter(
            (row) =>
              row.AssetGroupType?.toLowerCase().includes(
                searchTerm.toLowerCase()
              ) ||
              row.AssetTypes?.some((asset) =>
                asset.AssetName?.toLowerCase().includes(
                  searchTerm.toLowerCase()
                )
              )
          )
          .map((row) => {
            if (
              row.AssetGroupType?.toLowerCase().includes(
                searchTerm.toLowerCase()
              )
            ) {
              return row;
            } else {
              const matchingAssetTypes = row.AssetTypes?.filter((asset) =>
                asset.AssetName?.toLowerCase().includes(
                  searchTerm.toLowerCase()
                )
              );
              return {
                ...row,
                AssetTypes: matchingAssetTypes,
              };
            }
          })
      );
    }
    return () => setRows(projectAssets);
  }, [searchTerm]);

  const fetchProjectAssets = async (projectId) => {
    if (getProjectRawAssetsV2) {
      try {
        //@ts-ignore
        const { groupedResult, result } = await getProjectRawAssetsV2(
          projectId
        );
        console.log("@Project Assets-Raw", result);
        console.log("@Project Assets-Raw Grouped", groupedResult);
        setProjectRawAssets(result);
        const tranformRes = result.map((item) => {
          const AssetGroupType = assetGroups?.find(
            (i) => i.AssetGroupID === item.AssetGroupID
          )?.AssetGroupType;
          const AssetName = assetTypes?.find(
            (i) => i.AssetTypeID === item.AssetTypeID
          )?.AssetName;
          const SuffixName =
            (assetSuffixes &&
              assetSuffixes.find(
                ({ AssetGroupID, AssetTypeID, SuffixID }) =>
                  item.AssetGroupID === AssetGroupID &&
                  item.AssetTypeID === AssetTypeID &&
                  item.SuffixID === SuffixID
              )?.SuffixName) ||
            "N/A";

          return {
            ...item,
            AssetGroupType,
            AssetName,
          };
        });
        let rows = tableRows(tranformRes);
        let sortRows = rows.map((ele)=>{
          let sortAssetTypes =  ele.AssetTypes
            .sort((a, b) => a.AssetName.toLowerCase() > b.AssetName.toLowerCase() ? 1 : -1);
          return {...ele , AssetTypes: sortAssetTypes}
        })
        setRows(sortRows);
        setProjectAssets(sortRows);
        console.log("@@Units RAW 2:", rows , sortRows);
      } catch (error) {
        console.log("@@Units RAW Error:", error);
      }
    }
  };

  const fetchAssets = async () => {
    console.log("@@Fetch Assetd:");
    if (getAssetLookupV2) {
      try {
        const assetLookup = await getAssetLookupV2();
        console.log("@@Assetd Lookup:", assetLookup);
      } catch (error) {
        console.log("@@Service Areas Error:", error);
      }
    }
  };

  const handleDeleteRow = (
    AssetGroupID: string | undefined,
    AssetTypeID: string | undefined
  ) => {
    console.log(`## Delete Row for: ${AssetGroupID} , ${AssetTypeID}`);
    setDeleteRecords([
      ...deleteRecords,
      { AssetGroupID, AssetTypeID, ProjectID: selectedProject?.ID },
    ]);
    setDeletedialog(true);
    console.log("## INT OPS DEL Records: ", deleteRecords);
  };

  const handleSave = async () => {
    if (deleteRecords.length === 0) {
      return;
    }
    try {
      console.log("## SAVING DELETED RECORDS: ", deleteRecords);
      let records = projectRawAssets.filter((item) => {
        let found = deleteRecords.findIndex(
          (rec) =>
            item.AssetGroupID === rec.AssetGroupID &&
            item.AssetTypeID === rec.AssetTypeID
        );
        console.log(`## Delete Rows Found: ${found}`);
        return found >= 0;
      });

      if (deleteProjectUnitsV2) {
        const result = await deleteProjectUnitsV2(records);
        console.log(`## DELETE Rows to DB is: ${result}`);
        if (result) {
          setAlertMessage({
            message: "Changes have been saved successfully",
            type: "success",
          });
          setShowAlert(true);
          setDeleteRecords([]);
          fetchAssets();
          if (selectedProject) fetchProjectAssets(selectedProject.ID);
          setDeletedialog(false);
        }
      }
    } catch (err) {
      setDeletedialog(false);
      console.log(err);
    }
  };

  const handleEditClick = (groupId: string, typeId: string) => {
    console.log(`## Edit Row for: ${groupId}, ${typeId}`);
    setEditDialogOpen(true);
    setEditProps({ groupId, typeId });
  };

  const handleEditAltNameClick = async (AssetType: AssetTypes) => {
    console.log(
      `## Updating Unit: ${AssetType.OBJECTID}, ${AssetType.AlternateUnit}`
    );
    // const payload = {
    //   OBJECTID: objectId,
    //   AlternateUnit: altUnit,
    // };
    if (updateProjectUnitV2) {
      const result = await updateProjectUnitV2(AssetType);
      if (result) {
        if (selectedProject) fetchProjectAssets(selectedProject.ID);
        console.log("Successfully Updated Project Alternate Unit Name");
        showSnackbar?.(`Successfully Updated Alternate Unit Name`, "success");
      } else {
        console.log("Error in Updating Project Alternate Unit Name");
        showSnackbar?.(`Error in Updating Alternate Unit Name`, "error");
      }
    }
  };

  return (
    <Grid
      container
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      width='100%'
    >
      {showAlert && (
        <Alert message={alertMessage?.message} type={alertMessage?.type} />
      )}
      <AddProjectUnit
        config={{
          assetLookup,
          projectId: selectedProject?.ID,
          addProjectUnitsV2,
          deleteProjectUnitsV2,
          fetchAssets,
          projectAssets,
          projectRawAssets,
          fetchProjectAssets,
          setAlertMessage,
          setShowAlert,
          searchTerm,
          setSearchTerm,
          editDialogOpen,
          setEditDialogOpen,
          editProps,
          setEditProps,
          assetTypes,
          assetGroups,
          assetSuffixes,
          generateNewUnitID,
          addNewUnitsV2,
          getAssetTypesV2,
          intelliFiberUserRoles,
          user,
        }}
      />
      <UnitsTable
        rows={rows}
        onDelete={handleDeleteRow}
        handleEditClick={handleEditClick}
        handleEditAltNameClick={handleEditAltNameClick}
        isEditable={checkIsEditable}
      />
      <Dialog
        open={deletedialog}
        onClose={() => setDeletedialog(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {"Confirm Project Unit Deletion"}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeletedialog(false)}>Cancel</Button>
          <Button onClick={handleSave} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {loading ? (
        <Grid container justifyContent='center' alignItems='center'>
          <Loader />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default UnitsConfiguration;
